<template>
  <main class="ws-vertical">
    <!-- Header -->
    <!-- <header class="ws-header">
      <div class="ws-title">早产儿护理周总结</div>
      <div class="ws-sub">个性化护理建议，助力宝宝健康成长</div>
    </header> -->

    <!-- Loading状态 -->
    <div v-if="loading" class="loading">
      <p>正在生成周总结...</p>
    </div>

    <!-- 错误状态 -->
    <div v-else-if="error" class="error">
      <p>{{ error }}</p>
      <button @click="fetchSummaryData" class="retry-btn">重新加载</button>
    </div>

    <!-- 免费试用期已结束，不显示内容 -->
    <div v-else-if="showTrialExpiredMessage" class="trial-expired">
      <div class="trial-icon">⏰</div>
      <p>周总结和未来一周计划需要有每周电话回访和定期上门访视数据才能准确生成。</p>
      <!-- <button @click="goToPaymentPage" class="upgrade-btn">立即升级</button> -->
    </div>

    <!-- Summary Content -->
    <section v-else-if="summaryContent" class="ws-content">
      <!-- 免费试用期内的提示 -->
      <div v-if="showTrialWarning" class="trial-warning">
        <p class="warning-text">
          周总结和未来周计划需要有每周电话回访和定期上门访视数据才能准确生成。您尚未升级服务，因此我们为您提供的为期4周的【每周电话回访】服务将在{{ remainingWeeks }}周后停止，届时，周总结及未来周计划将无法继续生成。
        </p>
        <!-- <button @click="goToPaymentPage" class="warning-upgrade-btn">立即升级</button> -->
      </div>

      <div class="ws-card">
        <div class="ws-markdown-content" v-html="renderedMarkdown"></div>
      </div>
    </section>

    <!-- 空状态 -->
    <div v-else class="empty-state">
      <div class="empty-icon">📄</div>
      <p>暂无周总结数据</p>
      <button @click="fetchSummaryData" class="retry-btn">刷新</button>
    </div>
  </main>
</template>

<script>
import axios from 'axios';
import { TOKEN } from '@/utils/config';
import marked from 'marked';

export default {
    name: "WeeklySummary",
    data () {
        return {
            summaryContent: '', // AI总结内容
            loading: false, // 加载状态
            error: null, // 错误信息
            token: '', // 访问令牌
            isPaid: false, // 是否已付费
            userAddTime: null, // 用户注册时间
            showTrialExpiredMessage: false, // 是否显示试用期结束消息
            showTrialWarning: false, // 是否显示试用期警告
            remainingWeeks: 0 // 剩余周数
        };
    },
    computed: {
        renderedMarkdown () {
            if (!this.summaryContent) {
                return '';
            }

            try {
                marked.setOptions({
                    breaks: true,
                    gfm: true,
                    sanitize: false,
                    smartLists: true,
                    smartypants: false
                });

                const html = marked.parse(this.summaryContent);
                return html;
            } catch (error) {
                console.error('Markdown parsing error:', error);
                return '';
            }
        }
    },
    mounted () {
    // 获取 token
        let type = this.$route.query.type;
        if (type == 'test') {
            this.token = TOKEN;
        } else {
            let token = this.$route.query.token;
            this.token = token;
        }

        // 判断是否已付费
        const isPaidQuery = this.$route.query.isPaid;
        this.isPaid = isPaidQuery === 'true';

        // 获取用户信息和周总结数据
        this.fetchUserInfo();
    },
    methods: {
        // 获取用户信息
        async fetchUserInfo () {
            try {
                const response = await axios.get('https://api.yubinglabs.com/user/user', {
                    headers: {
                        Authorization: 'bearer ' + this.token,
                        channel: 1000
                    }
                });

                if (response.data.success && response.data.result) {
                    console.log('用户信息:', response.data.result);
                    this.userAddTime = parseInt(response.data.result.addtime, 10);
                    this.checkTrialStatus();
                } else {
                    // 如果获取用户信息失败，继续获取周总结
                    this.fetchSummaryData();
                }
            } catch (err) {
                console.error('获取用户信息失败:', err);
                // 如果获取用户信息失败，继续获取周总结
                this.fetchSummaryData();
            }
        },

        // 检查试用期状态
        checkTrialStatus () {
            // 如果已付费，直接获取周总结
            if (this.isPaid) {
                this.fetchSummaryData();
                return;
            }

            // 如果没有 addtime，直接获取周总结
            if (!this.userAddTime) {
                this.fetchSummaryData();
                return;
            }

            const currentTime = Math.floor(Date.now() / 1000); // 当前时间戳（秒）
            const fourWeeksInSeconds = 4 * 7 * 24 * 60 * 60; // 4周的秒数
            const trialEndTime = this.userAddTime + fourWeeksInSeconds;

            // 计算剩余时间（秒）
            const remainingSeconds = trialEndTime - currentTime;

            // 如果试用期已结束
            if (remainingSeconds <= 0) {
                this.showTrialExpiredMessage = true;
                return;
            }

            // 如果试用期未结束，计算剩余周数
            const oneWeekInSeconds = 7 * 24 * 60 * 60;
            this.remainingWeeks = Math.ceil(remainingSeconds / oneWeekInSeconds);
            this.showTrialWarning = true;

            // 获取周总结数据
            this.fetchSummaryData();
        },

        // 获取周总结数据
        async fetchSummaryData () {
            this.loading = true;
            this.error = null;

            try {
                const response = await axios.get('https://api.yubinglabs.com/aiplan/summary_weekly', {
                    headers: {
                        Authorization: 'bearer ' + this.token,
                        channel: 1000
                    }
                });

                if (response.data.success && response.data.result) {
                    this.summaryContent = response.data.result.plan_content || '';

                    if (!this.summaryContent.trim()) {
                        this.error = '暂无周总结数据';
                    }
                } else {
                    this.error = '获取周总结失败';
                }
            } catch (err) {
                console.error('获取周总结失败:', err);
                this.error = '网络错误，请检查网络连接';
            } finally {
                this.loading = false;
            }
        },

        // 跳转到支付页面
        goToPaymentPage () {
            // this.$router.push('/payment'); // 假设支付页面的路由是 /payment
            window.location.href = 'babycare://payment';
        }
    },
};
</script>

<style scoped>
/* 试用期结束样式 */
.trial-expired {
  text-align: center;
  padding: 60px 20px;
  color: var(--muted);
}

.trial-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.trial-expired p {
  font-size: 16px;
  color: var(--ink);
  margin-bottom: 24px;
  line-height: 1.6;
}

/* 试用期警告样式 */
.trial-warning {
  background: linear-gradient(135deg, #FFF9E6 0%, #FFF5D6 100%);
  border-left: 4px solid #FFC107;
  border-radius: 8px;
  padding: 16px;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.warning-text {
  flex: 1;
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  margin: 0;
}

.warning-upgrade-btn {
  flex-shrink: 0;
  width: 88px;
  height: 32px;
  border-radius: 6px;
  font-size: 14px;
  line-height: 32px;
  padding: 0;
  border: none;
  background: #FFC107;
  color: #333;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.warning-upgrade-btn:hover {
  opacity: 0.9;
}

/* 蒙层样式 */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-radius: 16px;
}

.overlay p {
  font-size: 16px;
  color: var(--muted);
  margin-bottom: 16px;
}

.upgrade-btn {
  width: 144px; /* 按钮宽度 */
  height: 36px; /* 按钮高度 */
  border-radius: 8px; /* 圆角 */
  font-size: 16px; /* 字体大小 */
  line-height: 22px; /* 行高，确保文字垂直居中 */
  padding: 0; /* 去掉默认内边距 */
  border: none; /* 无边框 */
  background: #05C2CB; /* 按钮背景色 */
  color: #fff; /* 按钮文字颜色 */
  font-family: "PingFang SC"; /* 字体 */
  font-weight: 600; /* 字体加粗 */
  cursor: pointer; /* 鼠标悬停时显示手型 */
  transition: opacity 0.2s; /* 添加过渡效果 */
}

.upgrade-btn:hover {
  opacity: 0.9; /* 鼠标悬停时透明度变化 */
}
/* 基础变量 */
:root {
  --ink: #1f2937;
  --muted: #6b7280;
  --line: #e5e7eb;
  --card: #fff;
  --accent: #05C2CB;
  --bg: #f8fafc;
}

.ws-vertical {
  max-width: 880px;
  margin: 0 auto;
  padding: 10px 14px 60px;
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "PingFang SC", "Noto Sans CJK SC", "Microsoft YaHei", sans-serif;
  color: var(--ink);
  background: var(--bg);
  min-height: 100vh;
}

/* Header */
.ws-header {
  text-align: center;
  margin-bottom: 24px;
}

.ws-title {
  font-weight: 800;
  font-size: 22px;
  color: var(--ink);
}

.ws-sub {
  font-size: 14px;
  color: var(--muted);
  margin-top: 4px;
}

/* 加载和错误状态 */
.loading, .error, .empty-state {
  text-align: center;
  padding: 60px 20px;
}

.loading p {
  font-size: 16px;
  color: var(--muted);
}

.error p {
  font-size: 16px;
  color: #ef4444;
  margin-bottom: 16px;
}

.empty-state {
  color: var(--muted);
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.empty-state p {
  font-size: 16px;
  margin-bottom: 16px;
}

.retry-btn {
  background: var(--accent);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: opacity 0.2s;
}

.retry-btn:hover {
  opacity: 0.9;
}

/* 内容区域 */
.ws-content {
  margin-top: 2px;
}

.ws-card {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.ws-card-header {
  background: linear-gradient(135deg, #05C2CB, #048B94);
  color: white;
  padding: 24px;
  text-align: center;
}

.ws-icon {
  font-size: 32px;
  margin-bottom: 8px;
}

.ws-card-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 4px;
}

.ws-card-subtitle {
  font-size: 14px;
  opacity: 0.9;
}

/* Markdown 内容样式 */
.ws-markdown-content {
  /* padding: 24px; */
  line-height: 1.6;
}

.ws-markdown-content :deep(h1) {
  color: var(--ink);
  font-size: 20px;
  font-weight: 700;
  margin: 0px 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--accent);
}

.ws-markdown-content :deep(h2) {
  color: var(--ink);
  font-size: 18px;
  font-weight: 700;
  margin: 20px 0 12px 0;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--line);
}

.ws-markdown-content :deep(h3) {
  color: var(--ink);
  font-size: 16px;
  font-weight: 600;
  margin: 18px 0 10px 0;
}

.ws-markdown-content :deep(h4) {
  color: var(--ink);
  font-size: 15px;
  font-weight: 600;
  margin: 16px 0 8px 0;
}

.ws-markdown-content :deep(p) {
  color: var(--ink);
  font-size: 14px;
  margin: 12px 0;
  line-height: 1.7;
}

.ws-markdown-content :deep(strong) {
  color: var(--accent);
  font-weight: 600;
}

.ws-markdown-content :deep(em) {
  color: var(--muted);
  font-style: italic;
}

.ws-markdown-content :deep(ul) {
  margin: 12px 0;
  padding-left: 20px;
}

.ws-markdown-content :deep(li) {
  color: var(--ink);
  font-size: 14px;
  margin: 6px 0;
  line-height: 1.6;
}

/* 移动端适配 */
@media (max-width: 640px) {
  .ws-vertical {
    padding: 12px 12px 40px;
  }
  
  .ws-title {
    font-size: 20px;
  }
  
  .ws-sub {
    font-size: 12px;
  }
  
  .ws-card-header {
    padding: 20px 16px;
  }
  
  .ws-card-title {
    font-size: 18px;
  }
  
  .ws-markdown-content {
    padding: 0 16px 20px 16px;
  }
  
  .ws-markdown-content :deep(h1) {
    font-size: 18px;
  }
  
  .ws-markdown-content :deep(h2) {
    font-size: 16px;
  }
  
  .ws-markdown-content :deep(h3) {
    font-size: 15px;
  }
  
  .ws-markdown-content :deep(p),
  .ws-markdown-content :deep(li) {
    font-size: 13px;
  }
}

/* 打印样式 */
@media print {
  .ws-vertical {
    background: white;
    max-width: none;
    padding: 0;
  }
  
  .retry-btn {
    display: none;
  }
  
  .ws-card {
    box-shadow: none;
    border: 1px solid #ddd;
  }
}
/* 表格样式 */
.ws-markdown-content :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 16px 0;
  border: 1px solid var(--line);
}

.ws-markdown-content :deep(th),
.ws-markdown-content :deep(td) {
  padding: 8px 12px;
  border: 1px solid var(--line);
  text-align: left;
  font-size: 14px;
}

.ws-markdown-content :deep(th) {
  background-color: #f8fafc;
  font-weight: 600;
}

.ws-markdown-content :deep(tr:nth-child(even)) {
  background-color: #f9f9f9;
}
/* 标题样式 */
.ws-markdown-content :deep(h1) {
  color: #0066cc;
  font-size: 32px;
  margin: 24px 0 12px;
}

.ws-markdown-content :deep(h2) {
  color: #0066cc;
  font-size: 28px;
  margin: 20px 0 10px;
}

.ws-markdown-content :deep(h3) {
  color: #0066cc;
  font-size: 24px;
  margin: 18px 0 8px;
}

/* 段落样式 */
.ws-markdown-content :deep(p) {
  font-size: 16px;
  margin-bottom: 12px;
  line-height: 1.6;
}

/* 表格样式 */
.ws-markdown-content :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 16px 0;
  border: 1px solid var(--line);
}

.ws-markdown-content :deep(th),
.ws-markdown-content :deep(td) {
  padding: 8px 12px;
  border: 1px solid var(--line);
  text-align: left;
  font-size: 14px;
}

.ws-markdown-content :deep(th) {
  background-color: #f8fafc;
  font-weight: 600;
}

.ws-markdown-content :deep(thead) {
  background-color: #e9f1f7;
}

.ws-markdown-content :deep(tr:nth-child(even)) {
  background-color: #f9f9f9;
}

/* 代码块样式 */
.ws-markdown-content :deep(pre) {
  background-color: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  overflow-x: auto;
}

.ws-markdown-content :deep(code) {
  background-color: #eee;
  padding: 2px 4px;
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Courier New', Courier, monospace;
}
/* 列表样式 */
.ws-markdown-content :deep(ul) {
  list-style-type: disc; /* 无序列表使用圆点符号 */
}

.ws-markdown-content :deep(ol) {
  list-style-type: decimal; /* 有序列表使用数字编号 */
}

.ws-markdown-content :deep(ul),
.ws-markdown-content :deep(ol) {
  font-size: 16px;
  margin-bottom: 12px;
  padding-left: 40px; /* 确保列表项有缩进 */
}

.ws-markdown-content :deep(li) {
  margin-bottom: 6px;
  line-height: 1.6; /* 增加行高，提升可读性 */
}
</style>